import { render, staticRenderFns } from "./ExamineDetail.vue?vue&type=template&id=4d352353&scoped=true&"
import script from "./ExamineDetail.vue?vue&type=script&lang=js&"
export * from "./ExamineDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamineDetail.vue?vue&type=style&index=0&id=4d352353&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d352353",
  null
  
)

export default component.exports